import axios from 'axios'
import { getBaseURL } from './config'
// 使用原生方法替代Element UI组件
// import { Message, Loading } from 'element-ui' // 如果使用Element UI，可以引入消息提示组件

// 创建axios实例

const timestamp = Math.floor(Date.now() / 1000).toString()
const account = '13011111111'
const appSecret = '?8t^71Rny+0Vdu:Y{6p?[%LUe{]PbAet'
const sign = md5(appSecret + '#' + timestamp + '#' + account).toString()
const service = axios.create({
  baseURL: getBaseURL(), // 根据环境设置baseURL
  timeout: 15000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'x-account': account,
    'x-appkey': 'rGTS&K2;cLyqi{&I',
    'x-device-id': '176837321245274adadsa',
    // 'x-sign': sign,
    'x-timestamp': timestamp
  }
})

// Loading管理 - 使用原生方法
let loadingInstance = null
let loadingCount = 0

// 显示loading
function showLoading() {
  if (loadingCount === 0) {
    // 创建loading元素
    loadingInstance = document.createElement('div')
    loadingInstance.id = 'api-loading'
    loadingInstance.innerHTML = `
      <div style='
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        color: white;
        font-size: 16px;
      '>
        <div style='text-align: center;'>
          <div style='
            width: 40px;
            height: 40px;
            border: 4px solid #f3f3f3;
            border-top: 4px solid #409EFF;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin: 0 auto 10px;
          '></div>
          加载中...
        </div>
      </div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `
    document.body.appendChild(loadingInstance)
  }
  loadingCount++
}

// 隐藏loading
function hideLoading() {
  if (loadingCount <= 0) return
  loadingCount--
  if (loadingCount === 0 && loadingInstance) {
    document.body.removeChild(loadingInstance)
    loadingInstance = null
  }
}

// 消息提示函数 - 替代Element UI的Message
function showMessage(message, type = 'info') {
  const messageEl = document.createElement('div')
  const typeColors = {
    success: '#67C23A',
    error: '#F56C6C',
    warning: '#E6A23C',
    info: '#409EFF'
  }

  messageEl.innerHTML = `
    <div style='
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: white;
      border: 1px solid ${typeColors[type]};
      border-radius: 4px;
      padding: 12px 16px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      z-index: 10000;
      color: ${typeColors[type]};
      font-size: 14px;
      min-width: 300px;
      text-align: center;
      animation: messageSlideIn 0.3s ease-out;
    '>
      ${message}
    </div>
    <style>
      @keyframes messageSlideIn {
        from {
          opacity: 0;
          transform: translateX(-50%) translateY(-20px);
        }
        to {
          opacity: 1;
          transform: translateX(-50%) translateY(0);
        }
      }
      @keyframes messageSlideOut {
        from {
          opacity: 1;
          transform: translateX(-50%) translateY(0);
        }
        to {
          opacity: 0;
          transform: translateX(-50%) translateY(-20px);
        }
      }
    </style>
  `

  document.body.appendChild(messageEl)

  // 3秒后自动移除
  setTimeout(() => {
    if (messageEl && messageEl.parentNode) {
      messageEl.firstElementChild.style.animation = 'messageSlideOut 0.3s ease-out'
      setTimeout(() => {
        if (messageEl && messageEl.parentNode) {
          document.body.removeChild(messageEl)
        }
      }, 300)
    }
  }, 3000)
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 显示loading（可选）
   /*  if (config.showLoading !== false) {
      showLoading()
    } */

    // 添加token到请求头
    const token = localStorage.getItem('token') || sessionStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    // 添加时间戳防止缓存（GET请求）
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      }
    }

    console.log('请求发送:', config)
    return config
  },
  error => {
    hideLoading()
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    hideLoading()

    const { data, config } = response

    // Return raw data for blob responses
    if (config.responseType === 'blob') {
      return data
    }

    // 根据后端约定的状态码处理响应
    if (data.code === 200 || data.success === true) {
      // 成功响应
      return data.data || data
    } else if (data.code === 401) {
      // token过期或无效
      // showMessage('登录已过期，请重新登录', 'error')
      // localStorage.removeItem('token')
      // sessionStorage.removeItem('token')
      // // 跳转到登录页
      // window.location.href = '/login'
      // return Promise.reject(new Error('登录已过期'))
    } else {
      // 业务错误
      /* const errorMsg = data.message || data.msg || '请求失败'
      if (config.showError !== false) {
        showMessage(errorMsg, 'error')
      } */
      // return Promise.reject(new Error(errorMsg))
    }
  },
  error => {
    hideLoading()

    let errorMessage = '网络错误'

    if (error.response) {
      // 服务器响应了错误状态码
      const { status, data } = error.response
      switch (status) {
        case 400:
          errorMessage = data.message || '请求参数错误'
          break
        case 401:
          errorMessage = '未授权，请重新登录'
          localStorage.removeItem('token')
          sessionStorage.removeItem('token')
          window.location.href = '/login'
          break
        case 403:
          errorMessage = '拒绝访问'
          break
        case 404:
          errorMessage = '请求的资源不存在'
          break
        case 500:
          errorMessage = '服务器内部错误'
          break
        case 502:
          errorMessage = '网关错误'
          break
        case 503:
          errorMessage = '服务不可用'
          break
        case 504:
          errorMessage = '网关超时'
          break
        default:
          errorMessage = `连接错误${status}`
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      errorMessage = '网络连接超时'
    } else {
      // 其他错误
      errorMessage = error.message || '请求失败'
    }

    console.error('响应错误:', error)

    // 显示错误消息（可通过配置关闭）
    if (error.config && error.config.showError !== false) {
      showMessage(errorMessage, 'error')
    }

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/index.js